// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Bucu","title":"Header_title__3UkzE","left":"Header_left__1M12S","clinicName":"Header_clinicName__Exfrv"};